import * as React from 'react'
import { Radio, RadioGroup } from 'react-radio-group'

import {
  IBooleanOption,
  IRadioSelectorProps
} from '../../../../../typings/searchResults'
import * as styles from './radioSelector.module.css'

class RadioSelector extends React.Component<IRadioSelectorProps> {
  public static defaultProps = { options: [] }

  public render() {
    const { radioName, selectedValue, onChange, options } = this.props

    return (
      <RadioGroup
        name={radioName}
        className={styles.optionsWrapper}
        selectedValue={selectedValue}
        onChange={onChange}
      >
        {this.renderOptions(options)}
      </RadioGroup>
    )
  }

  private renderOptions(options: IBooleanOption[]) {
    return options.map(option => {
      return (
        <div key={option.value} className={styles.optionWrapper}>
          <label>
            <Radio value={option.value} className={styles.radioInput} />
            <span className={styles.radioLabel}>{option.label}</span>
          </label>
          <span className={styles.count}>{option.count}</span>
        </div>
      )
    })
  }
}

export default RadioSelector
